import React from 'react';
import {
    WidgetTruncatedText, WidgetLinkTruncatedText
} from '../../../../components';
import { useTranslation } from 'react-i18next';
import { WidgetPrice } from '../../../../components/widget/WidgetPrice';

export default function ExpirationsColumns () {
    const { t } = useTranslation();
    return [{
        dataField: 'id_internal_account',
        text: t('expirations.table.columns.id'),
        align: 'left',
        headerAlign: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
    },
    {
        dataField: 'formatted_name',
        text: t('expirations.table.columns.client'),
        headerClasses: 'clientsColumnsMC_headers--title',
        align: 'left',
        headerAlign: 'left',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) =>
            <WidgetTruncatedText text={cellContent || '-'} truncated='false' styles={{ color: '#000000', textDecoration: 'none' }}/>
    },
    {
        dataField: 'document',
        text: t('expirations.table.columns.document'),
        headerClasses: 'clientsColumnsMC_headers--title',
        align: 'left',
        headerAlign: 'left',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/clients/details/${row.id_user || ''}`} text={cellContent || 'S/D'} truncated='false'/>)

    },

    {
        dataField: 'last_four',
        text: t('expirations.table.columns.lastFour'),
        align: 'left',
        headerAlign: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) =>
            <WidgetLinkTruncatedText to={`/clients/card/${row.id_user}`} text={cellContent || ''} truncated='false'/>
    },

    {
        dataField: 'pending_payment',
        text: t('expirations.table.columns.balance'),
        sort: true,
        align: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
        headerAlign: 'left',
        formatter: cellContent => (<WidgetPrice number={cellContent} textAlign={'left'}/>)
        // eslint-disable-next-line react/display-name, react/no-multi-comp
    }

    ];
}
